import clsx from 'clsx';
import { memo } from 'react';

interface WorkCurtainBackgroundProps {
	show: boolean;
}

function WorkCurtainBackgroundBase({ show }: WorkCurtainBackgroundProps) {
	return (
		<div
			className={clsx(
				'absolute left-0 top-0 z-30 h-full w-full bg-radial-gradient from-baseStrong-800 to-black duration-1000',
				{
					'opacity-100': show,
					'opacity-0': !show,
				}
			)}
		></div>
	);
}

const WorkCurtainBackground = memo(WorkCurtainBackgroundBase);

export default WorkCurtainBackground;
